import { PayloadAction } from "@reduxjs/toolkit";

import { BrandsState } from '../../types';

export const setAddingFavouriteBrandsStatus = (
  state: BrandsState,
  action: PayloadAction<BrandsState['favouriteBrands']['addingStatus']>
) => {
  state.favouriteBrands.addingStatus = action.payload;
};
